import HttpFactory from '../factory'

class DASignerModule extends HttpFactory {
  async getDeclarations(code, uuid, lang = undefined) {
    const url = `/declaration_of_authorisation/declarations/${code}`
    let querystring = ``
    if (uuid) {
      querystring += `?uuid=${uuid}`
    }
    if (lang) {
      querystring += querystring === `` ? `?lang=${lang}` : `&lang=${lang}`
    }
    return await this.call(`get`, url + querystring)
  }

  async generateDA(data, uuid, lang = undefined) {
    console.log(`lang`, lang)
    const url = `/declaration_of_authorisation/generate`
    let querystring = ``
    if (uuid) {
      querystring += `?uuid=${uuid}`
    }
    if (lang) {
      querystring += querystring === `` ? `?lang=${lang}` : `&lang=${lang}`
    }
    return await this.call(`post`, url + querystring, data)
  }

  async sendSignature(data) {
    return await this.call(`post`, `/declaration_of_authorisation/send_signature`, data)
  }

  async getSignature(data) {
    const token = data.token
    return await this.call(`get`, `/declaration_of_authorisation/send_signature?token=${token}`)
  }
}

export default DASignerModule
